import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as LayoutActions from './layout.actions';
import * as LayoutSelectors from './layout.selectors';
import { LayoutState } from './layout.reducer';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  
  constructor(private store: Store<{ layout: LayoutState }>) {}
  
  // Sidebar methods
  toggleSidebar(): void {
    this.store.dispatch(LayoutActions.toggleSidebar());
  }
  
  showSidebar(): void {
    this.store.dispatch(LayoutActions.showSidebar());
  }
  
  hideSidebar(): void {
    this.store.dispatch(LayoutActions.hideSidebar());
  }
  
  // Header methods
  toggleHeader(): void {
    this.store.dispatch(LayoutActions.toggleHeader());
  }
  
  showHeader(): void {
    this.store.dispatch(LayoutActions.showHeader());
  }
  
  hideHeader(): void {
    this.store.dispatch(LayoutActions.hideHeader());
  }
  
  // Footer methods
  toggleFooter(): void {
    this.store.dispatch(LayoutActions.toggleFooter());
  }
  
  showFooter(): void {
    this.store.dispatch(LayoutActions.showFooter());
  }
  
  hideFooter(): void {
    this.store.dispatch(LayoutActions.hideFooter());
  }
  
  // Combined layout methods
  toggleLayout(): void {
    this.store.dispatch(LayoutActions.toggleLayout());
  }
  
  showLayout(): void {
    this.store.dispatch(LayoutActions.showLayout());
  }
  
  hideLayout(): void {
    this.store.dispatch(LayoutActions.hideLayout());
  }
  
  setLayoutVisibility(sidebarVisible: boolean, headerVisible: boolean, footerVisible: boolean): void {
    this.store.dispatch(LayoutActions.setLayoutVisibility({ sidebarVisible, headerVisible, footerVisible }));
  }
  
  // Selectors
  get sidebarVisible$(): Observable<boolean> {
    return this.store.select(LayoutSelectors.selectSidebarVisible);
  }
  
  get headerVisible$(): Observable<boolean> {
    return this.store.select(LayoutSelectors.selectHeaderVisible);
  }
  
  get footerVisible$(): Observable<boolean> {
    return this.store.select(LayoutSelectors.selectFooterVisible);
  }
  
  get layoutVisible$(): Observable<boolean> {
    return this.store.select(LayoutSelectors.selectLayoutVisible);
  }
  
  get layoutHidden$(): Observable<boolean> {
    return this.store.select(LayoutSelectors.selectLayoutHidden);
  }
  
  get partialLayoutVisible$(): Observable<boolean> {
    return this.store.select(LayoutSelectors.selectPartialLayoutVisible);
  }
  
  get layoutStateSummary$(): Observable<{
    sidebarVisible: boolean;
    headerVisible: boolean;
    footerVisible: boolean;
    allVisible: boolean;
    allHidden: boolean;
  }> {
    return this.store.select(LayoutSelectors.selectLayoutStateSummary);
  }
  
  // Synchronous state access (for one-time checks)
  getCurrentState(): LayoutState {
    let currentState: LayoutState | undefined;
    this.store.select(LayoutSelectors.selectLayoutState).subscribe(state => {
      currentState = state;
    }).unsubscribe();
    return currentState || { sidebarVisible: true, headerVisible: true, footerVisible: true };
  }
}
